/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import game from '../game/index';

export default {
  setShowPleaseWait(state, payload) {
    state.showPleaseWait = payload;
  },
  setBonusPhasesNum(state, payload) {
    state.bonusPhasesNum = payload;
  },
  setMonthlyButton(state, payload) {
    state.monthlyButton = payload;
  },
  setGrandButton(state, payload) {
    state.grandButton = payload;
  },
  setWeeklyButton(state, payload) {
    state.weeklyButton = payload;
  },
  setAllWinners(state, payload) {
    state.allWinners = payload;
  },
  setPerformanceInfo(state, payload) {
    state.performanceInfo = payload;
  },
  setGameTypeWinnersForLeaderboard(state, payload) {
    state.gameTypeWinnersForLeaderboard = payload;
  },
  setGameTypeRankForLeaderboard(state, payload) {
    state.gameTypeRankForLeaderboard = payload;
  },
  setUserAchievements(state, achievements) {
    state.achievements = achievements.map(achievement => ({
      ...achievement,
      achievementDTOs: achievement.achievementDTOs.map(ad => ({
        ...ad,
        achievementLevelDTOs: ad.achievementLevelDTOs.map((ald, index) => ({
          ...ald,
          index,
        })),
      })),
    }));
  },
  storeAchievementNotificationData(state, payload) {
    state.achievementNotificationData = payload.notifications;
  },
  setRedeemedNotification(state, notificationId) {
    const matchingNotifications = state.notifications.filter(notification => notification.id === notificationId);
    if (matchingNotifications.length) {
      const { gameId } = matchingNotifications[0];
      state.notifications = state.notifications.map(notification => (notification.id === notificationId || notification.gameId === gameId ? { ...notification, readStatus: true } : notification));
      state.achievementNotificationData = state.achievementNotificationData.map(notification => (notification.id === notificationId || notification.gameId === gameId ? { ...notification, readStatus: true } : notification));
    }
  },
  updatePhaseBonusModalToBeDisplayed(state, phase) {
    state.phaseBonusModalToBeDisplayed = phase;
  },
  savePhaseBonusList(state, bonus) {
    state.phaseBonusList = bonus;
    state.bonusPhasesNum = bonus.length;
  },
  saveBonusDailyModal(state, daily) {
    state.bonusDailyModal = daily;
  },
  setMoreWinnersButton(state, show) {
    state.moreWinnersButton = show;
  },
  setMoreWinnersMButton(state, show) {
    state.moreWinnersMButton = show;
  },
  setMoreWinnersIButton(state, show) {
    state.moreWinnersIButton = show;
  },
  totalWinners(state, payload) {
    state.totalWinners = payload.value;
  },
  setInWinners(state, payload) {
    state.instantWin = payload;
  },
  setGrWinners(state, payload) {
    state.grandWin = payload;
  },
  setMoWinners(state, payload) {
    state.monthlyWin = payload;
  },
  setJackpotRanks(state, payload) {
    state.jackpotRankData = payload;
  },
  setJackpotPrizes(state, payload) {
    state.jackpotPrizes = payload;
  },
  clearAllData(state) {
    state.showmodalBundleId = false;
    state.notifications = [];
    state.dailyPrize = {};
    state.dailyWinners = [];
    state.dailyRank = {};
    state.weeklyPrize = {};
    state.weeklyRank = {};
    state.weeklyWinners = [];
    state.monthlyPrize = {};
    state.monthlyWinners = [];
    state.monthlyRank = {};
    state.visitorWinners = [];
    state.grandPrize = {};
    state.puzzleGame = null;
    state.lanternGame = null;
    state.isAddOnGameModalShown = false;
  },
  setHashedPassForForgotPass(state, pass) {
    state.hashedPass = pass;
  },
  setSuccessForReoptinWith2StepVerificationVerified(state, booleanVal) {
    state.twoStepVerificationVerified = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationWrongPin(state, booleanVal) {
    state.twoStepVerificationWrongPin = booleanVal;
  },
  setSuccessForReoptinWith2StepVerificationServerError(state, booleanVal) {
    state.twoStepVerificationServerError = booleanVal;
  },
  storeNotificationsFromSocket(state, payload) {
    const { notifications } = payload;
    if (notifications.notificationCategoryDTO.notifName !== 'ZERO_BALANCE') state.notifications.push(notifications);
    if (notifications.notificationCategoryDTO.name === 'Achievement') state.achievementNotificationData.push(notifications);
  },
  setForgotPasswordInfo(state, payload) {
    state.forgotPasswordInfo = payload;
  },
  storeNotifications(state, payload) {
    state.notifications = payload.notifications.filter(notif => notif.notificationCategoryDTO.notifName !== 'ZERO_BALANCE');
  },
  setMonthlyPrize(state, payload) {
    state.monthlyPrize = payload.value;
  },
  setGrandPrize(state, payload) {
    state.grandPrize = payload.value;
  },
  setDailyPrize(state, payload) {
    state.dailyPrize = payload.value;
  },
  setWeeklyPrize(state, payload) {
    state.weeklyPrize = payload.value;
  },
  setCarouselPrizes(state, payload) {
    state.carouselPrizes = payload.value;
  },
  setRequestPinResponse(state, payload) {
    state.requestPinResponse = payload.value;
  },
  setChargePinResponse(state, payload) {
    state.chargePinResponse = payload.value;
  },
  setBundles(state, payload) {
    state.storedBundles = payload.value;
  },
  setRegistrationInfo(state, payload) {
    state.registrationInfoMsisdn = payload;
  },
  setMonthlyPrizeForLeaderboard(state, payload) {
    state.monthlyPrizeForLeaderboard = payload;
  },
  setGrandPrizeForLeaderboard(state, payload) {
    state.grandPrizeForLeaderboard = payload;
  },
  setDailyPrizeForLeaderboard(state, payload) {
    state.dailyPrizeForLeaderboard = payload;
  },
  setWeeklyPrizeForLeaderboard(state, payload) {
    state.weeklyPrizeForLeaderboard = payload;
  },
  setMonthlyWinnersForLeaderboard(state, payload) {
    state.monthlyWinnersForLeaderboard = payload;
  },
  setGrandWinnersForLeaderboard(state, payload) {
    state.grandWinnersForLeaderboard = payload;
  },
  setDailyWinnersForLeaderboard(state, payload) {
    state.dailyWinnersForLeaderboard = payload;
  },
  setWeeklyWinnersForLeaderboard(state, payload) {
    state.weeklyWinnersForLeaderboard = payload;
  },
  setMonthlyRankForLeaderboard(state, payload) {
    state.monthlyRankForLeaderboard = payload;
  },
  setGrandRankForLeaderboard(state, payload) {
    state.grandRankForLeaderboard = payload;
  },
  setDailyRankForLeaderboard(state, payload) {
    state.dailyRankForLeaderboard = payload;
  },
  setWeeklyRankForLeaderboard(state, payload) {
    state.weeklyRankForLeaderboard = payload;
  },
  setAvailablePrizeTypes(state, payload) {
    state.availablePrizeTypes = payload;
  },
  setjwtFromStorage(state, jwt) {
    state.jwtInVuex = jwt;
  },
  setFirstTimeEntry(state, firstEntry) {
    state.firstTimeEntry = firstEntry;
  },
  setCheckedNotificationId(state, payload) {
    state.checkedNotificationId = payload.value;
  },
  setCheckedNotificationReadStatus(state, payload) {
    state.checkedNotificationReadStatus = payload.value;
  },
  setNotificationRewardId(state, payload) {
    state.notificationRewardId = payload.value;
  },
  setNotificationPrizeWon(state, payload) {
    state.notificationPrizeWon = payload.value;
  },
  setNotificationRewardName(state, payload) {
    state.notificationRewardName = payload.value;
  },
  setShowmodalForDefaultPrizeDetails(state, payload) {
    state.showmodalForDefaultPrizeDetails = payload.notificationPrizeDetailsObject;
  },
  setShowmodalForRanking(state, payload) {
    state.showmodalForRanking = {};
    state.showmodalForRanking.userLevel = payload.notificationRankingObject.userLevel;
    state.showmodalForRanking.bonusPoints = payload.notificationRankingObject.bonusPoints;
    state.showmodalForRanking.gamesToNextLevel = payload.notificationRankingObject.gamesToNextLevel;
  },
  setShowmodalForLevelUp(state, payload) {
    game.state.playersDetails = {};
    game.state.playersDetails.currentLevel = payload.notificationLevelupObject.userLevel;
    game.state.playersDetails.levelUpPoints = payload.notificationLevelupObject.bonusPoints;
    game.state.playersDetails.gamesToNextLevel = payload.notificationLevelupObject.gamesToNextLevel;
  },
  setUserAuthorized(state, status) {
    state.userAuthorized = status;
  },
  setProfilePath(state, profilePath1) {
    state.profilePath = profilePath1;
  },
  setBundleId(state, bundleId) {
    state.bundleId = bundleId;
  },
  setBundleData(state, payload) {
    state.bundleData = {};
    state.bundleData.currencyCode = payload.bundleDataObject.currencyCode;
    state.bundleData.price = payload.bundleDataObject.price;
    state.bundleData.numberOfCoins = payload.bundleDataObject.numberOfCoins;
    state.bundleData.points = payload.bundleDataObject.points;
  },
  storeThemes(state, themes) {
    state.themes = themes;
  },
  storeGameHistoryData: (state, payload) => {
    state.gameHistoryData = payload.value;
  },
  setOppDetails(state, payload) {
    state.opponentDetails = payload.details;
  },
  setGameDetails(state, payload) {
    state.gameDescriptionDetails = payload.details;
  },
  setShowHistory(state, show) {
    state.showHistory = show;
  },
  saveLanternGame(state, data) {
    state.lanternGame = data;
  },
  savePuzzleGame(state, data) {
    state.puzzleGame = data;
  },
  setIsAddonGameModalShown(state, value) {
    state.isAddOnGameModalShown = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js